export default __webpack_public_path__ + "static/B0049-429800cf939b4789a4e675afeb2c080e.png";